export const IS_VUEJS_ENVIRONMENT = false; // for production or dev-drupal environment this value should be set to "false". this value is only used for dev purp>
export const IS_PRODUCTION_ENVIRONMENT = true; // for production or active envrionment setup this value should be set to true.

export const LOCALHOST_API_URL = 'https://driving-olsapi-service.cms-uat.yukon.ca/api/'; // production api URL
export const DEVELOPMENT_API_URL = 'https://localhost:4330/api/'; // development api URL
export const DEFAULT_ROOT_URL = '/';  // default url path, for yg production website: /driving-transportation/
export const DEFAULT_ROOT_URL_FR = '/fr/';  // default url path, for yg production website: /driving-transportation/fr/

export const DEFAULT_USER_INACTIVITY_TIME = 15 * 60; // 15 minutes. This value is set from default value, but if none setup in db this one is used
export const USER_INACTIVITY_LOGOUT_TIME = 3;  // 3 seconds after warning is showed user is logged out
export const USER_INACTIVITY_PAYMENT_TIME = 10 * 60;

export const API_UNAVAILABLE_MESSAGE = {
    title: "<p class='ml-3'>Sorry, there is a problem with this service. Try again later.</p>",
    description: "<p class='ml-8'>Email <a href='mailto:motor.vehicles@yukon.ca'>motor.vehicles@yukon.ca</a> or phone <a href='tel:867-667-5315'>867-667-5315</a>"
};
